import { useRouteError } from "react-router-dom";

import NotFoundPage from "./404";
import ServerError from "./500";

export default function ErrorPage() {
  const error: any = useRouteError();

  if (error.status === 404) return <NotFoundPage />;

  return <ServerError />;
}
